import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";

export default function QuestionsStarter({
    onCancelQuestions,
    setRenderType,
    getSessionTerms,
    bookInfo = undefined,
    practitionerInfo,
    url = undefined,
    boo,
    setSaveTerms,
    saveterms,
    bookingType,
    getSubsessions,
    activeSessionId,
    getPractitionarsList,
    activesession_id,
    openBackfillpopup
}) {
    const { t } = useTranslation("clientBooking");
    const auth = useSelector((state) => state.user);
    const [error, setError] = useState(false);
    const [checkall, setCheckAll] = useState(false);



    const [check16, setCheck16] = useState(false);
    // const [checkYes, setCheckYes] = useState(false);
    // const [checkNo, setCheckNo] = useState(false);

    useEffect(() => {
        bookingType !== "outreach" && setCheck16(true);
    }, []);
    const changeHandler = (e, setCheck, type) => {
        // if (type === "radio") {
        // setCheckYes(e.target.value);
        // }
        setCheck(e.target.checked);

        // if(check1 && check2 && check3 && check7 && check8 && check9 && check10 && check11 && check12 && check13 && check14){
        //   setCheckAll(e.target.checked);
        // }
        // else{
        //   setCheckAll(e.target.checked);
        // }
        // else if(!check1 || !check2 || !check3 || !check7 || !check8 || !check9 || !check10 || !check11 || !check12 || !check13 || !check14){
        //   setCheckAll(false);
        // }
    };

    const changeHandlerAll = (e) => {
        setCheckAll(e.target.checked);

    };



    // const onClickSaveTerms = () => {
    //     console.log("validate", validator());

    //     if (validator()) {
    //         setError(false);

    //         if (activesession_id === "5" && auth.user.terms_session_status !== 1) {
    //             setSaveTerms(1);
    //             getSessionTerms(1);
    //         }
    //         if (activesession_id === "3" && auth.user.terms_session_starter_status !== 1) {
    //             getSessionTerms(1);
    //         }
    //     } else {
    //         setError(true);
    //     }
    // };

    const onClickHandler = () => {
        if (checkall) {
            setError(false);

            if (activesession_id === "5" && auth.user.terms_session_status !== 1) {
                setSaveTerms(1);
                getSessionTerms(1);
            }
            if (activesession_id === "3" && auth.user.terms_session_starter_status !== 1) {
                getSessionTerms(1);
            }

            console.log(bookingType, "bookingType");
            if (bookingType === "outreach") {
                openBackfillpopup('newappointment');
                // setRenderType("newappointment");
                localStorage.setItem("type", "newappointment");
            } else if (bookingType === "starter") {
                setRenderType("newappointment");
                localStorage.setItem("type", "newappointment");
            }
            else {
                if (bookingType == "professional") {
                    // openBackfillpopup('');
                    getPractitionarsList()
                }
                // getPractitionarsList()
            }
        } else {
            setError(true);
        }
    };

    return (
        <div class="container-fluid question-container">
            {console.log(activesession_id, "activesession_id")}
            <div class="row justify-content-center">
                <div class="col-11 col-sm-10 col-md-10 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
                    <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
                        <form id="msform">
                            <fieldset>
                                <div class="form-card">
                                    <div class="row wrap">
                                        <h2 className="text-center">
                                            {t("terms.readConfirm")}
                                        </h2>
                                       
                                        <div class="new margin-unset">
                                            <div class="form-group">
                                                <input
                                                    onChange={(e) => {
                                                        changeHandlerAll(e);
                                                    }}
                                                    checked={checkall}
                                                    name="checkall"
                                                    type="checkbox"
                                                    id="checkall"
                                                />
                                                <label htmlFor="checkall">{t("starterTerms.agreeToAll")}</label>
                                            </div>
                                        </div>
                                        <h2>{t("starterTerms.iUnderstandSpaced")}</h2>
                                        <div class="new margin-unset">
                                            <div>

                                                <ul>
                                                    <li className="starter-label">
                                                        {t("starterTerms.understand1")}</li>
                                                    <li className="starter-label">{t("starterTerms.understand2")}</li>
                                                    <li className="starter-label">{t("starterTerms.understand3")}</li>
                                                </ul>

                                            </div>

                                            <h2>{t("terms.iWill")}</h2>
                                            <div >
                                                <ul>
                                                    <li className="starter-label">
                                                        <Trans i18nKey="starterTerms.will1" ns="clientBooking" components={{ u: <span className="text-underline" /> }} /></li>
                                                    <li className="starter-label">{t("starterTerms.will2")}</li>
                                                    <li className="starter-label">{t("starterTerms.will3")}</li>
                                                    <li className="starter-label">{t("starterTerms.will4")}</li>
                                                    <li className="starter-label"><Trans i18nKey="starterTerms.will5" ns="clientBooking" components={{ u: <span className="text-underline" /> }} /></li>
                                                    <li className="starter-label">{t("starterTerms.will6")}</li>

                                                </ul>
                                            </div>

                                            {/*****In understabd */}
                                            <h2>{t("terms.iUnderstandThat")}</h2>
                                            <div >
                                                <ul>
                                                    <li className="starter-label">
                                                        {t("starterTerms.that1")}
                                                    </li>
                                                    <li className="starter-label">{t("starterTerms.that2")}</li>
                                                    <li className="starter-label">{t("starterTerms.will3")}</li>
                                                    <li className="starter-label">{t("starterTerms.that4")}</li>
                                                    <li className="starter-label">{t("starterTerms.that5")}</li>
                                                    <li className="starter-label">{t("starterTerms.will6")}</li>

                                                </ul>
                                            </div>


                                            {error && (
                                                <div>
                                                    <p className="red">
                                                        {t("terms.selectAll")}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <input
                                    onClick={onCancelQuestions}
                                    type="button"
                                    name="previous"
                                    class="previous action-button-previous"
                                    value={t("buttons.cancel")}
                                />
                                <input
                                    onClick={onClickHandler}
                                    type="button"
                                    name="next"
                                    class="next action-button"
                                    value={t("buttons.next")}
                                />
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
